// ═══ 평가사 메모 1종 + AI 번역 (신고 371 §9 결정 6 / 신고 383 자동 번역) ═══
// 원문은 한국어라 비한국어 로케일이면 열 때 자동 번역해 번역문을 기본 표시 + [원문 보기] 토글.
// 로케일 전환은 부모가 key 에 locale 을 넣어 새로 마운트 → 이전 언어 번역 잔존 없음.
// 실패(502·빈 결과)는 자동 재시도 없이 원문 + [번역 보기] 버튼(수동 재시도), 503 TRANSLATION_UNAVAILABLE 은 버튼 숨김.
// props: { title, text, field, orderId, locale }
import React, { useState, useEffect, useRef } from 'react';
import { T, R, FONT } from '../../../../theme';
import { useT } from '../../../../../i18n/I18nProvider';
import { notesTranslation } from '../../../api';

var box = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, padding: '13px 14px' };
var head = { fontSize: FONT.cardTitle, fontWeight: 800, color: T.ink, marginBottom: 8 };
var text = { fontSize: 12, color: T.body, lineHeight: 1.6, whiteSpace: 'pre-wrap', margin: 0 };
var btn = { marginTop: 9, height: 28, padding: '0 11px', borderRadius: R.sm, border: '1px solid ' + T.bd,
  background: T.head, color: T.body, fontSize: 11.5, fontWeight: 700, cursor: 'pointer',
  fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center' };
var outLabel = { fontSize: FONT.label, fontWeight: 700, color: T.muted, marginBottom: 4 };
var busyLabel = { marginTop: 7, fontSize: FONT.label, color: T.muted };
var errText = { marginTop: 7, fontSize: 11.5, color: T.danger };

function NoteBlock(props) {
  var t = useT();
  var stT = useState(''); var out = stT[0], setOut = stT[1];
  var stB = useState(false); var busy = stB[0], setBusy = stB[1];
  var stE = useState(''); var err = stE[0], setErr = stE[1];
  var stH = useState(false); var hidden = stH[0], setHidden = stH[1];
  var stO = useState(false); var showOrig = stO[0], setShowOrig = stO[1];
  var seq = useRef(0);   // 낡은 응답·언마운트 후 setState 차단

  var translate = function () {
    var id = ++seq.current;
    setBusy(true);
    setErr('');
    notesTranslation(props.orderId, { lang: props.locale, field: props.field }).then(function (body) {
      if (seq.current !== id) return;
      setBusy(false);
      var value = (body && body.translated) || '';
      if (value) setOut(value);
      else setErr(t('errorGeneric'));
    }, function (e) {
      if (seq.current !== id) return;
      setBusy(false);
      // 번역 서비스 미가동 — 재시도해도 같으므로 버튼 자체를 걷는다(리포트 동작과 동일 취지).
      if (e && e.code === 'TRANSLATION_UNAVAILABLE') { setHidden(true); return; }
      setErr(t('errorGeneric'));
    });
  };

  useEffect(function () {
    if (props.locale === 'ko' || !props.text) return undefined;
    translate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return function () { seq.current++; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.orderId, props.field, props.locale]);

  var showTr = !!out && !showOrig;
  var canTranslate = props.locale !== 'ko' && !hidden && !out && !busy;
  return (<div className="ss-note-block" data-field={props.field} style={box}>
    <div style={head}>{props.title}</div>
    {showTr ? <div style={outLabel}>{t('inspNotesTranslatedLabel')}</div> : null}
    <p style={text}>{showTr ? out : props.text}</p>
    {busy ? <div style={busyLabel}>{t('inspNotesTranslating')}</div> : null}
    {canTranslate ? (<button type="button" data-action="translate" style={btn} onClick={translate}>
      {t('inspNotesTranslate')}
    </button>) : null}
    {out ? (<button type="button" data-action="toggle" style={btn} onClick={function () { setShowOrig(!showOrig); }}>
      {showOrig ? t('inspNotesTranslate') : t('inspNotesOriginal')}
    </button>) : null}
    {err ? <div style={errText}>{err}</div> : null}
  </div>);
}

export default NoteBlock;
